import { useState, useEffect } from 'react';

interface GeolocationData {
  city?: string;
  country?: string;
  location?: string;
}

export function useGeolocation() {
  const [location, setLocation] = useState<GeolocationData>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchLocation();
  }, []);

  const fetchLocation = async () => {
    try {
      // Using a free IP geolocation service
      const response = await fetch('https://ipapi.co/json/');
      if (response.ok) {
        const data = await response.json();
        setLocation({
          city: data.city,
          country: data.country_name,
          location: `${data.city}, ${data.country_name}`
        });
      }
    } catch (error) {
      console.log('Could not fetch geolocation:', error);
    } finally {
      setLoading(false);
    }
  };

  return { location, loading };
}
